import React from "react";
import { PDFLinkTracker } from "../forms/controls";

type DocumentLinkProps = {
    title?: string;
    url?: string;
    target?: string;
};

const DocumentLink = ({ title, url, target = "_self" }: DocumentLinkProps) => (
    <PDFLinkTracker
        label={title}
        target={target}
        pdfUrl={url || ""}
        disableTracking={true}
    />
);

export { DocumentLink };
